import React, { act, useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useSubscription } from './SubscriptionsProvider';

const ProtectedRoute = ({ children, allowWithoutSubscription = false, ...rest }) => {
  
  const { isAuthenticated, expiresAt, logout } = useAuth();
  const { activePlan, setToInitialState } = useSubscription();
  const isActivePlan = activePlan.plan !== null && activePlan.plan !== undefined;
  const subscriptionExpired = activePlan.end_date !== null 
      && activePlan.end_date !== undefined 
      && new Date(activePlan.end_date) < new Date().toISOString();

  const handleLogout = async () => {
    const success = await logout();
    if (!success) {
      alert('Logout failed');
    }
    setToInitialState();
  };

  useEffect(() => {
    if (expiresAt !== '' && expiresAt !== null && expiresAt !== undefined) {
      const timeUntilLogout = new Date(expiresAt) - new Date();
      if (timeUntilLogout > 0) {
        const timer = setTimeout(() => {
          console.log("Session expired, logging out.")
          handleLogout();
        }, timeUntilLogout);
        
        return () => clearTimeout(timer); // Cleanup to avoid multiple timers
      } else {
        handleLogout(); // If already expired, log out immediately
      }
    }
  }, [expiresAt, logout]);


  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!isAuthenticated) {
          return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
        }

        if (subscriptionExpired) {
          return <Redirect to={{ pathname: '/plans', state: { from: location } }} />;
        }

        // Allow users to access certain routes without an active subscription
        if (!isActivePlan && !allowWithoutSubscription) {
          return <Redirect to={{ pathname: '/plans', state: { from: location } }} />;
        }

        return children;
      }}
    />
  );
};

export default ProtectedRoute;